import { render, staticRenderFns } from "./computationNum.vue?vue&type=template&id=06f714df&scoped=true&"
import script from "./computationNum.vue?vue&type=script&lang=js&"
export * from "./computationNum.vue?vue&type=script&lang=js&"
import style0 from "./computationNum.vue?vue&type=style&index=0&id=06f714df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f714df",
  null
  
)

export default component.exports